// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
    background-color: #191818 !important;
    color: white !important;
    width: 283px !important;
    /* height: 231px !important; */
    position: fixed !important;
    top: 71px !important;
    right: 0 !important;
    outline: none !important;
}

.main-box {
    border-bottom: 2px solid #0D0D0D !important;
    padding:20px 15px !important;
}

.Cards-Row {
    display: flex !important;
    flex-direction: row !important;
    gap: 16px !important;
    margin-top: 20px !important;
    flex-wrap: wrap !important;
}

.main-title {
    font-family: "Poppins" !important; 
    font-weight: 500 !important; 
    font-size: 18px !important;
    line-height: 27px !important;
}

/*card */
.Card-Content {
    width: -moz-fit-content !important;
    width: fit-content !important;
    cursor:pointer !important;
}
 
.Card-logo {
    padding: 13px 15px !important;
    background-color: #0C0C0C !important;   
    width: 50px !important;
    height: 50px !important;
    border-radius: 8px !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    overflow: hidden !important;
    box-sizing: border-box !important;
}

.Card-title {
    width: 35px !important;
    height: 26px !important;
    text-align: center !important;
    font-size: 10px !important;
    font-family: 'Poppins' !important;
    font-weight: 500 !important;
    line-height: 13px !important;
    margin-left: auto !important;
    margin-right: auto !important;
    padding-top: 5px !important;
}

/* right side bar footer css */
.footer-modal {
    border-top: 2px solid #0D0D0D !important;
    height: 69px !important;
    padding: 16px 15px 20px !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/ui/RightSideBarModal/rightSideBarStyle.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,2CAA2C;IAC3C,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;IACpB,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA,QAAQ;AACR;IACI,kCAA6B;IAA7B,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;IACpC,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,wBAAwB;IACxB,kCAAkC;IAClC,8BAA8B;IAC9B,2BAA2B;IAC3B,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,0BAA0B;IAC1B,iCAAiC;IACjC,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;IAC5B,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA,8BAA8B;AAC9B;IACI,wCAAwC;IACxC,uBAAuB;IACvB,kCAAkC;AACtC","sourcesContent":[".main {\n    background-color: #191818 !important;\n    color: white !important;\n    width: 283px !important;\n    /* height: 231px !important; */\n    position: fixed !important;\n    top: 71px !important;\n    right: 0 !important;\n    outline: none !important;\n}\n\n.main-box {\n    border-bottom: 2px solid #0D0D0D !important;\n    padding:20px 15px !important;\n}\n\n.Cards-Row {\n    display: flex !important;\n    flex-direction: row !important;\n    gap: 16px !important;\n    margin-top: 20px !important;\n    flex-wrap: wrap !important;\n}\n\n.main-title {\n    font-family: \"Poppins\" !important; \n    font-weight: 500 !important; \n    font-size: 18px !important;\n    line-height: 27px !important;\n}\n\n/*card */\n.Card-Content {\n    width: fit-content !important;\n    cursor:pointer !important;\n}\n \n.Card-logo {\n    padding: 13px 15px !important;\n    background-color: #0C0C0C !important;   \n    width: 50px !important;\n    height: 50px !important;\n    border-radius: 8px !important;\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n    overflow: hidden !important;\n    box-sizing: border-box !important;\n}\n\n.Card-title {\n    width: 35px !important;\n    height: 26px !important;\n    text-align: center !important;\n    font-size: 10px !important;\n    font-family: 'Poppins' !important;\n    font-weight: 500 !important;\n    line-height: 13px !important;\n    margin-left: auto !important;\n    margin-right: auto !important;\n    padding-top: 5px !important;\n}\n\n/* right side bar footer css */\n.footer-modal {\n    border-top: 2px solid #0D0D0D !important;\n    height: 69px !important;\n    padding: 16px 15px 20px !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
